/**
 * @generated SignedSource<<dd2c030caa291c534e32882cf8a5c372>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useDomainName_company$data = {
  readonly id: string;
  readonly name: string | null | undefined;
  readonly " $fragmentType": "useDomainName_company";
};
export type useDomainName_company$key = {
  readonly " $data"?: useDomainName_company$data;
  readonly " $fragmentSpreads": FragmentRefs<"useDomainName_company">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useDomainName_company",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "type": "Company",
  "abstractKey": null
};

(node as any).hash = "551c82de713017dbd7a8ada6214a297f";

export default node;
